import React from 'react';
import { StartingScreensaverUI } from '../../ui_components/StartingScreensaverUI';

export const StartingScreensaver = () => {
    return (
        <StartingScreensaverUI></StartingScreensaverUI>
    )
};
